<template>
  <form @submit.prevent="handleSubmit">
    <div>
      <div class="caption">{{ $t('customer_name') }}</div>
      <v-text-field
        v-model="form.name"
        v-validate="'required'"
        outline
        single-line
        :data-vv-as="$t('customer_name')"
        name="name"
        :error-messages="errors.first('name')"
        :disabled="loading"
      />
    </div>
    <div>
      <div class="caption">{{ $t('account_type') }}</div>
      <v-select
        v-model="form.type"
        v-validate="'required'"
        outline
        single-line
        :items="typeOptions"
        :data-vv-as="$t('account_type')"
        name="type"
        :error-messages="errors.first('type')"
        :disabled="loading"
      />
    </div>
    <div>
      <div class="caption">{{ $t('phone_number') }}</div>
      <v-text-field
        v-model="form.phone"
        v-validate="'required|numeric'"
        type="tel"
        outline
        single-line
        :data-vv-as="$t('phone_number')"
        name="phone"
        :error-messages="errors.first('phone')"
        :disabled="loading"
      />
    </div>
    <div>
      <div class="caption">{{ $t('project_or_village') }}</div>
      <v-text-field
        v-model="form.project"
        outline
        single-line
        :data-vv-as="$t('project_or_village')"
        name="project"
        :error-messages="errors.first('project')"
        :disabled="loading"
      />
    </div>
    <div :style="{ display: 'flex', justifyContent: 'flex-end', flexWrap: 'wrap', gap: '1rem' }">
      <v-btn class="ma-0" :disabled="loading" @click="$emit('cancel')">{{ $t('cancel') }}</v-btn>
      <v-btn type="submit" color="primary" :loading="loading" class="ma-0">{{ $t('Save') }}</v-btn>
    </div>
  </form>
</template>

<script>
import { MEMBER_TYPE_OPTIONS } from '@/constants/juzmatch'

export default {
  props: {
    value: {
      type: Object,
      default: undefined
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: this.value
        ? {
            name: this.value.full_name || '',
            type: this.value.member_type || '',
            phone: this.value.identity_card_no || '',
            project: this.value.project || ''
          }
        : {
            name: '',
            type: '',
            phone: '',
            project: ''
          }
    }
  },
  computed: {
    typeOptions() {
      return MEMBER_TYPE_OPTIONS.map((option) => ({
        ...option,
        text: this.$t(`juzmatch_member_type.${option.text}`)
      }))
    }
  },
  methods: {
    async handleSubmit() {
      const valid = await this.$validator.validate()
      if (!valid) return
      this.$emit('submit', this.form)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/Juzmatch/MemberEditForm.vue